/** * Created by lobin on 2019/1/24. */
<template>
  <div :class="step > -1?'infoBg':''">
    <div style="height: 20px;"></div>
    <div class="completeresume boxShadow">
      <div class="completeresume-upload" v-if="step === -1">
        <h2>上传附件</h2>
        <el-upload
          class="upload-demo"
          drag
          :show-file-list="false"
          :on-success="uploadResumeAction"
          :before-upload="beforeUploadAction"
          :action="$store.state.uploadResume"
          :headers="{ token: token }"
        >
          <!-- <i class="el-icon-upload"></i> -->
         
          <div class="el-upload__text">拖拽文件到这里，快速上传</div>
          <div class="el-upload__subtext">请上传DOC、DOCX、PDF格式的中文</div>
          <div class="el-upload__btn">选择文件上传</div>
         
         
        </el-upload>
      </div>
      <!-- <el-steps :space="200" :active="step" align-center simple v-if="step > -1">
        <el-step title="基本信息"></el-step>
        <el-step title="个人评价"></el-step>
        <el-step title="求职意向"></el-step>
        <el-step title="教育经历"></el-step>
        <el-step title="工作经历"></el-step>
        <el-step title="项目经验"></el-step>
      </el-steps> -->
      <div class="completeresume-content">
        <p v-if="step === 0" class="completeresume-content-onetitle">欢迎来到IT内推圈</p>
        <p v-if="step === 0" class="completeresume-content-onesubtitle">解析基本信息，快速创建您的在线简历</p>

        <p v-if="step === 1" class="completeresume-content-onetitle">自我评价</p>
        <p v-if="step === 1" class="completeresume-content-onesubtitle">让面试官更好的了解您</p>

        <p v-if="step === 2" class="completeresume-content-onetitle">您的期望</p>
        <p v-if="step === 2" class="completeresume-content-onesubtitle">更精准的为您匹配</p>
        
        <p v-if="step === 3" class="completeresume-content-onetitle">最高学历的教育经历</p>
        <p v-if="step === 3" class="completeresume-content-onesubtitle">完善教育经历，为你的简历加分</p>

        <p v-if="step === 4" class="completeresume-content-onetitle">填写您最近的一份工作经验</p>
        <p v-if="step === 4" class="completeresume-content-onesubtitle">完善工作经验，为您的简历加分</p>

        <p v-if="step === 5" class="completeresume-content-onetitle">填写您最近的项目经验</p>
        <p v-if="step === 5" class="completeresume-content-onesubtitle">完善项目经验，为您的简历加分</p>


        <!-- 基本信息 -->
        <el-form
          v-if="step === 0"
          :model="baseInfo"
          :rules="baseInforules"
          ref="baseInfo"
          label-width="100px"
          class="myresume-form"
         
          size="small"
        >
          <el-row :gutter="20">

            <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="姓名" prop="jobSeekerName">
                <el-input
                  v-model="baseInfo.jobSeekerName"
                  placeholder="请输入姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号" prop="phone">
                <el-input
                  v-model="baseInfo.phone"
                  placeholder="请输入手机号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="邮箱" prop="email">
                <el-input
                  v-model="baseInfo.email"
                  placeholder="请输入邮箱"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="微信号" prop="jobSeekerWechatId">
                <el-input
                  v-model="baseInfo.jobSeekerWechatId"
                  placeholder="请输入微信号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="性别" prop="gender">
                <el-radio-group v-model="baseInfo.gender">
                  <el-radio
                    :label="item.code"
                    v-for="item in gender"
                    :key="item.code"
                    :value="item.code"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="毕业学校" prop="graduateSchool">
                <el-input
                  v-model="baseInfo.graduateSchool"
                  placeholder="请输入毕业学校"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="专   业" prop="majorSubjects">
                <el-input
                  v-model="baseInfo.majorSubjects"
                  placeholder="请输入最高学历所学专业"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="学历" prop="qualificationsType">
                <el-select
                  v-model="baseInfo.qualificationsType"
                  placeholder="请选择最高学历"
                >
                  <el-option
                    :label="item.name"
                    v-for="item in qualificationsType"
                    :key="item.code"
                    :value="item.code"
                    >{{ item.name }}</el-option
                  >
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="出生年月" prop="birthday">
                <el-date-picker
                  type="month"
                  placeholder="选择日期"
                  v-model="baseInfo.birthday"
                  :picker-options="pickerOptionsEnd"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所在城市" prop="currentAreaId">
                <el-input
                  v-model="baseInfo.currentAreaId"
                  placeholder="请输入所在城市"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="目前职位" prop="positionName">
                <el-input
                  v-model="baseInfo.positionName"
                  placeholder="请输入目前职位"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
            <el-col :span="24" style="text-align: right;margin-top: 30px;">
              <el-button @click="step = 1" v-if="progress !== 0">跳过</el-button>
              <el-button type="primary" @click="editUserInfo">保存</el-button>
            </el-col>
          </el-row>
        </el-form>
        <!-- 个人评价 -->
        <el-form
          v-if="step === 1"
          :model="baseInfo"
          :rules="baseInforules"
          ref="baseInfo"
          label-width="100px"
          class="myresume-form"
          label-position="top"
        >
          <el-form-item label="个人评价" prop="personalAdvantage" class="editor">
            <quill-editor
              v-model="baseInfo.personalAdvantage"
              ref="myQuillEditor"
              :options="editorOption"
            >
            </quill-editor>
          </el-form-item>
          <el-form-item style="text-align: right;">
            <el-button @click="step = 2">跳过</el-button>
            <el-button type="primary" @click="modiySelfEvaluation">保存</el-button>
          </el-form-item>
        </el-form>
        
        <!-- 个人期望 -->
        <!-- <div class="completeresume-list analyzing-resumes" v-if="step === 2">
          <el-form
            :model="baseInfo"
            :rules="baseInforules"
            ref="jobIntention"
            label-width="100px"
            class="myresume-form"
          >
          <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="求职类型" prop="qualificationsType">
                  <el-select
                    v-model="baseInfo.expectedPositionType"
                    placeholder="请选择职位类型"
                  >
                    <el-option
                      :label="item.name"
                      v-for="item in positionType"
                      :key="item.code"
                      :value="item.code"
                      >{{ item.name }}</el-option
                    >
                  </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
            <el-form-item label="职业类型：" prop="desirePositionType">
              <el-cascader
                  style="width: 100%;"
                  placeholder="职业类型"
                  v-model="jobExpectData.desirePositionType"
                  :options="allJob"
                  :props="{ expandTrigger:'hover',value:'code',label:'name'}"
                  @change="handleChange('desirePositionType',jobExpectData.desirePositionType )"
                  >
              </el-cascader>
            </el-form-item>
          </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="16">
            <el-form-item label="行业类型：" prop="desireIndustry">
              <el-select
                v-model="jobExpectData.desireIndustry"
                placeholder="请选择行业类型"
              >
                <el-option
                  :label="item.name"
                  v-for="item in industryType"
                  :key="item.code"
                  :value="item.code"
                  >{{ item.name }}</el-option
                >
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="16">
            <el-form-item label="期望城市：" prop="desireCity">
              <el-select
                v-model="jobExpectData.desireCity"
                placeholder="请选择期望城市"
              >
                <el-option
                  :label="item.cityName"
                  v-for="item in positionArea"
                  :key="item.cityCode"
                  :value="item.cityCode"
                  >{{ item.cityName }}</el-option
                >
              </el-select>
            </el-form-item>
          </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="16">
              <div class="flex">
                <el-form-item label="期望薪酬：" prop="desireSalaryMin">
                    <el-input v-model="jobExpectData.desireSalaryMin" placeholder="最低薪酬"></el-input>
                </el-form-item>
                <p style="padding:8px 6px 0 ;color: rgba(0,0,0,0.5);">至</p>
                <el-form-item label="" prop="desireSalaryMax" label-width="0">
                      <el-input v-model="jobExpectData.desireSalaryMax" placeholder="最高薪酬"></el-input>
                </el-form-item>
              </div>
            </el-col> 
          </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="目前状态" prop="currentState">
                  <el-select
                    v-model="baseInfo.currentState"
                    placeholder="请选择目前状态"
                  >
                    <el-option
                      :label="item.name"
                      v-for="item in currentState"
                      :key="item.code"
                      :value="item.code"
                      >{{ item.name }}</el-option
                    >
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="期望职位" prop="expectedPositionNames">
                  <el-input
                    v-model="baseInfo.expectedPositionNames"
                    placeholder="请输入期望职位"
                  ></el-input>
                </el-form-item>
              </el-col>
            
              <el-col :span="12">
                <el-form-item label="期望月薪" prop="qualificationsType">
                  <el-select
                    v-model="baseInfo.expectedSalaryRange"
                    placeholder="请选择期望月薪"
                  >
                    <el-option
                      :label="item.name"
                      v-for="item in salaryRange"
                      :key="item.code"
                      :value="item.code"
                      >{{ item.name }}</el-option
                    >
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="到岗时间" prop="arriveDate">
                  <el-input
                    v-model="baseInfo.arriveDate"
                    placeholder="请输入到岗时间"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="目前薪水" prop="currentSalary">
                  <el-input
                    v-model="baseInfo.currentSalary"
                    placeholder="请输入目前薪水"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="期望城市" prop="expectedCity">
                  <el-input
                    v-model="baseInfo.expectedCity"
                    placeholder="请输入期望城市"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24" style="text-align: right;">
                <el-button @click="step = 3">跳过</el-button>
                <el-button type="primary" @click="jobIntentionSubmitAction"
                  >保存</el-button
                >
              </el-col>
            </el-row>
          </el-form>
        </div> -->

        <div class=" completeresume-list  completeresume-list-jobexpect analyzing-resumes "  v-if="step === 2">
          <h3 class="flexBetween">
            <div class="flex completeresume-list-jobexpect-title">求职意向</div>
            <span class="edit completeresume-list-jobexpect-edit"
              @click="addJobExpectList('new')"
              v-if="JobExpectateList.length < 5">
              <i class="el-icon-circle-plus-outline"></i>&nbsp;添加</span>
          </h3>
          <div v-for="(item, index) in JobExpectateList" :key="index" style="margin-bottom: 10px;">
            <div class="" v-if="!JobExpectateEdit[index]">
              <h2 class="">{{ item.desirePositionTypeName}}</h2>
              <div class="flexBetween">
                  <div style="width: 50%;" class="shrink">
                  <p>薪资要求：{{ item.desireSalaryMin}}-{{ item.desireSalaryMax }} K/月</p>
                  <p>工作性质：{{item.jobHuntTypeName}} </p>
                  </div>
                  <div style="width: 40%;" class="shrink">
                  <p>期望城市：{{item.desireCityName}} </p>
                  <p>期望行业：{{item.desireIndustryName}} </p>
                  </div>
                  <div class="edit-tools shrink">
                  <i
                    class="el-icon-edit"
                    @click="changeEditStatu('JobExpectateEdit', index)"
                  ></i>&nbsp;
                  <i
                    class="el-icon-delete"
                    @click="deleteJobExpectItem('delJobExpect', item.id)"
                  ></i>
                </div>
              </div>
              
            </div>
            <jobExpectEdit
              :type="JobExpectateStatus"
              v-if="JobExpectateEdit[index]"
              cancelText="取消"
              v-model="JobExpectateList[index]"
              :index="index"
              @submit="jobExpectEditSuc"
            />
          </div>
          <el-row >
            <el-col :span="24" style="text-align: right;">
                <el-button type="primary" @click="step = 3">下一步</el-button>
                <!-- <el-button type="primary" @click="step = 3">保存</el-button> -->
              </el-col>
          </el-row>
        </div>

        <!-- 教育经历 -->
        <div class="completeresume-list analyzing-resumes" v-if="step === 3">
          <el-collapse v-model="eduactiveNames" accordion>
            <el-collapse-item
              :title="`${index + 1}.${item.schoolName || '学校名称'}`"
              :name="index"
              v-for="(item, index) in educationalBackgroundList"
              :key="index"
            >
              <el-row :gunter="20" v-if="!educationalEdit[index]">
                <el-col :span="12"> 学校:{{ item.schoolName }} </el-col>
                <el-col :span="12">
                  学历:{{ item.qualificationsTypeDisplay }}
                </el-col>
                <el-col :span="12"> 专业:{{ item.majorSubjects }} </el-col>
                <el-col :span="12"> 上学时间:{{ item.startTime }} </el-col>
                <el-col :span="12"> 毕业时间:{{ item.endTime }} </el-col>
              </el-row>
              <div class="edit-tools" v-if="!educationalEdit[index]">
                <i class="el-icon-edit" @click="editEducational(index)"></i>
                <!-- <i class="el-icon-delete"></i> -->
              </div>
              <educationEdit
                v-if="educationalEdit[index]"
                cancelText="跳过"
                v-model="educationalBackgroundList[index]"
                :index="index"
                @submit="educationEditSuc"
              />
            </el-collapse-item>
          </el-collapse>
        </div>

        <!-- 工作经历 -->
        <div class="completeresume-list analyzing-resumes" v-if="step === 4">
          <el-collapse v-model="workactiveNames" accordion>
            <el-collapse-item
              :title="`${index + 1}.${item.companyName || '公司名称'}`"
              :name="index"
              v-for="(item, index) in workExperienceList"
              :key="index"
            >
              <el-row :gunter="20" v-if="!workEdit[index]">
                <el-col :span="12"> 公司名称:{{ item.companyName }} </el-col>
                <el-col :span="12">
                  职位类别:{{ item.industryTypeDisplay }}
                </el-col>
                <el-col :span="12"> 职位名称:{{ item.positionName }} </el-col>
                <el-col :span="12"> 开始时间:{{ item.startDate }} </el-col>
                <el-col :span="12"> 结束时间:{{ item.endDate }} </el-col>
                <el-col :span="24">
                  <p v-html="item.workContent"></p>
                </el-col>
              </el-row>
              <div class="edit-tools" v-if="!workEdit[index]">
                <i class="el-icon-edit" @click="workEditAction(index)"></i>
                <!-- <i class="el-icon-delete" @click="workDelete(index,item.id)"></i> -->
              </div>
              <wordEdit
                v-if="workEdit[index]"
                :type="workEditStatus"
                cancelText="跳过"
                v-model="workExperienceList[index]"
                :index="index"
                @submit="workEditSuc"
              />
            </el-collapse-item>
          </el-collapse>
        </div>

        <!-- 项目经历 -->
        <div class="completeresume-list analyzing-resumes" v-if="step === 5">
          <el-collapse v-model="projectactiveNames" accordion>
            <el-collapse-item
              :title="`${index + 1}.${item.projectName || '项目名称'}`"
              :name="index"
              v-for="(item, index) in projectExperienceList"
              :key="index"
            >
              <el-row :gunter="20" v-if="!projectEdit[index]">
                <el-col :span="12">
                  项目名称:{{ item.projectName || "未命名" }}
                </el-col>
                <el-col :span="12"> 项目角色:{{ item.projectRole }} </el-col>
                <el-col :span="12"> 开始时间:{{ item.projectStartDate }} </el-col>
                <el-col :span="12">
                  结束时间:<span v-if="item.projectEndDate == '1970-01'"
                    >至今</span
                  ><span v-else>{{ item.projectEndDate }}</span>
                </el-col>
                <el-col :span="24">
                  <p v-html="item.projectDuty"></p>
                </el-col>
              </el-row>
              <div class="edit-tools" v-if="!projectEdit[index]">
                <i class="el-icon-edit" @click="projectEditAction(index)"></i>
                <!-- <i class="el-icon-delete" @click="projectDelete(index,item.id)"></i> -->
              </div>
              <projectEdit
                v-if="projectEdit[index]"
                :type="projectEditStatus"
                cancelText="跳过"
                v-model="projectExperienceList[index]"
                :index="index"
                @submit="projectEditSuc"
              />

            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <el-dialog
        title="简历已完善"
        center
        :visible.sync="dialogVisible"
        width="30%"
      >
        <div style="text-align: center">
          简历完善成功前往 <router-link to="/myresume">我的简历</router-link>
        </div>
      </el-dialog>
    </div>
    <div style="height: 20px;"></div>
  </div>
</template>

<script type="text/babel">
import { mapActions, mapGetters,mapState } from "vuex";
import { regular } from "../../libs/utilts";
import educationEdit from "./components/educationEdit.vue";
import wordEdit from "./components/workEdit.vue";
import projectEdit from "./components/projectkEdit.vue";
import jobExpectEdit from './components/jobExpectEdit.vue';
export default {
  components: { educationEdit, wordEdit, projectEdit ,jobExpectEdit},
  data() {
    return {
      fullloading: null,
      resumeUploading: false,
      eduactiveNames: 0,
      jobExpectNames:0,
      dialogVisible: false,
      workactiveNames: 0,
      projectactiveNames: 0,
      baseInfo: {},
      projectExperienceList: [{}],
      workExperienceList: [{}],
      educationalBackgroundList: [{}],
      step: 0,
      educationalEdit: {0: true},
      //jobExpectEdit: {0: true},
     
     
      // workEdit:{
      //   0:true
      // },
      // projectEdit:{
      //   0:true
      // },
      workEdit: [true],
      jobExpectEdit: [true],
      projectEdit: [true],
      editorOption: {},
      projectEditStatus: "add", // 项目经验添加编辑按钮
      jobExpectEditStatus:"add",
      workEditStatus: "add", // 工作经历添加编辑按钮

      JobExpectateList:[],  //求职期望列表
      JobExpectateEdit:{0:false}, //求职期望
      JobExpectateStatus: "edit", // 求职期望添加编辑按钮
    };
  },
  async created() {
    this.step = Number(this.$route.query.step) - 1;
    await this.getAllJob();
    await this.getPositionArea();
    const expect = await this.getJobExpect();  
    this.JobExpectateList = expect.data || [];
    //this.JobExpectateList=[];
    if(this.JobExpectateList && this.JobExpectateList.length>0){
      //this.changeEditStatu('JobExpectateEdit',0)
    }else{
      this.addJobExpectList("new");
    }
    
  },
  computed: {
    ...mapGetters([
      "gender",
      "qualificationsType",
      "currentState",
      "salaryRange",
      "positionType",
      "industryType",   //行业类型
    ]),
    ...mapState({
        positionArea:state => state.jobs.positionArea,
        allJob:state => state.jobs.allJob,
      }),

    
    progress() {
      const p = Number(this.$store.state.user.info.progress);
      return p;
    },
    token() {
      return window.localStorage.getItem("token");
    },
    educationRules() {
      return {
        schoolName: [
          { required: true, trigger: "blur", message: "用户姓名必填" }
        ],
        qualificationsType: [
          { required: true, trigger: "blur", message: "用户姓名必填" }
        ],
        majorSubjects: [
          { required: true, trigger: "blur", message: "用户姓名必填" }
        ]
      };
    },
    baseInforules() {
      const phoneReg = regular.phone;
      // 验证手机号码
      const validatorPhone = async (rule, value, callback) => {
        if (!value) {
          return callback(new Error("用户名不能为空!!"));
        }
        if (!phoneReg.test(value)) {
          return callback(new Error("电话号码不符合规则"));
        } else {
          callback();
        }
      };
      return {
        jobSeekerName: [
          { required: true, trigger: "blur", message: "用户姓名必填" }
        ],
        phone: [
          { required: true, trigger: "change", validator: validatorPhone }
        ],
        currentState: [
          { required: true, trigger: "change", message: "目前状态必选" }
        ],
        gender: [{ required: true, trigger: "change", message: "性别必填" }],
        qualificationsType: [
          { required: true, trigger: "change", message: "学历必填" }
        ],
        birthday: [
          { required: true, trigger: "blur", message: "出生年月必填" }
        ],
        currentAreaId: [
          { required: true, trigger: "blur", message: "所在城市必填" }
        ],
        majorSubjects: [
          { required: true, trigger: "blur", message: "专业必填" }
        ],
        graduateSchool: [
          { required: true, trigger: "blur", message: "毕业学校必填" }
        ],
        jobSeekerWechatId: [
          { required: true, trigger: "blur", message: "微信号" }
        ],
        personalAdvantage: [
          { required: true, trigger: "blur", message: "个人评价必填" }
        ],
        email: [{ required: true, trigger: "blur", message: "邮箱必填" }],
        arriveDate: [
          { required: true, trigger: "blur", message: "到岗时间必填" }
        ],
        expectedCity: [
          { required: true, trigger: "blur", message: "期望城市必填" }
        ],
        positionName: [
          { required: true, trigger: "blur", message: "目前职位必填" }
        ],
        currentSalary: [
          { required: true, trigger: "blur", message: "目前薪水必填" }
        ],
        expectedPositionNames: [
          { required: true, trigger: "blur", message: "期望职位必填" }
        ]
      };
    },
    pickerOptionsEnd() {
      return {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      };
    }
  },
  methods: {
    ...mapActions([
      "modifyUserBaseInfo",
      "addEducation",
      "delProjectExperience",
      "delWorkExperience",
      "getSelfUserInfo",
      "getJobExpect",
      "delJobExpect",
      "getAllJob",   //所有职位
      "getPositionArea",
    ]),
    async editUserInfo() {
      const validate = await this.$refs["baseInfo"].validate();
      if (!validate) return;
      const res = await this.modifyUserBaseInfo({
        birthday: this.baseInfo.birthday,
        email: this.baseInfo.email,
        jobSeekerName: this.baseInfo.jobSeekerName,
        jobSeekerWechatId: this.baseInfo.jobSeekerWechatId,
        phone: this.baseInfo.phone,
        currentAreaId: this.baseInfo.currentAreaId,
        gender: this.baseInfo.gender,
        qualificationsType: this.baseInfo.qualificationsType
      });
      if (res.code === 200) {
        this.$message.success("修改成功");
        this.nextStep();
      } else {
        this.$message.error(res.message);
      }
    },
    async modiySelfEvaluation() {
      const validate = this.baseInfo.personalAdvantage;
      if (!validate) return;
      const res = await this.modifyUserBaseInfo({
        personalAdvantage: this.baseInfo.personalAdvantage
      });
      if (res.code === 200) {
        this.$message.success("修改成功");
        this.nextStep();
      }
    },
    async jobIntentionSubmitAction() {
      const validate = await this.$refs["jobIntention"].validate();
      if (!validate) return;
      const {
        arriveDate,
        currentSalary,
        currentState,
        expectedCity,
        expectedPositionNames,
        expectedPositionType,
        expectedSalaryRange,
        positionName
      } = this.baseInfo;
      const res = await this.modifyUserBaseInfo({
        arriveDate,
        currentSalary,
        currentState,
        expectedCity,
        expectedPositionNames,
        expectedPositionType,
        expectedSalaryRange,
        positionName
      });
      if (res.code === 200) {
        this.$message.success("修改成功");
        this.nextStep();
      }
    },
    async uploadResumeAction({ data }) {
      this.baseInfo = data.baseInfo;
      this.educationalBackgroundList =
        data.educationalBackgroundList.length > 0
          ? data.educationalBackgroundList
          : [{}];
      this.projectExperienceList =
        data.projectExperienceList.length > 0
          ? data.projectExperienceList
          : [{}];
      this.workExperienceList =
        data.workExperienceList.length > 0 ? data.workExperienceList : [{}];
        const expect = await this.getJobExpect();  
        this.JobExpectateList = expect.data || [];
        //this.addJobExpectList("new");
      this.fullloading.close();
      let arr = [];
      for (let val of this.projectExperienceList) {
        arr.push(true);
      }
      this.projectEdit = arr;
      let workArr = [];
      for (let val of this.workExperienceList) {
        workArr.push(true);
      }
      this.workEdit = workArr;
      // workEdit
      this.nextStep();
    },
    async nextStep() {
      if (this.step === 5) {
        await this.getSelfUserInfo();
        return (this.dialogVisible = true);
      }
      this.step++;
      this.$router.push({ path: `/resumeoptimize?step=${this.step}` });
    },
    educationEditSuc(index) {
      const eduLength = this.educationalBackgroundList.length;
      if (eduLength > index + 1) {
        this.eduactiveNames = index + 1;
        this.resetEdit("educationalEdit");
        this.educationalEdit[index + 1] = true;
      } else {
        this.nextStep();
      }
    },
    
    // 删除项目
    async projectDelete(index, id) {
      const { code } = await this.delProjectExperience(id);
      if (code == 200) {
        this.projectEdit.splice(index, 1);
        this.projectExperienceList.splice(index, 1);
      }
    },
    // 删除工作经历
    async workDelete(index, id) {
      console.log(id);

      const { code } = await this.delWorkExperience(id);
      if (code == 200) {
        this.workEdit.splice(index, 1);
        this.workExperienceList.splice(index, 1);
      }
    },
    workEditAction(index) {
      this.workEditStatus = "edit";
      console.log(this.workEdit);

      this.workEdit[index] = true;

      console.log(this.workEdit);
    },
    workEditSuc({ index, type }) {
      const eduLength = this.workExperienceList.length;
      this.workEditStatus = "add";
      if (eduLength > index + 1) {
        this.workactiveNames = index + 1;
        if (type) {
          this.workEdit[index] = true;
        } else {
          this.workEdit[index] = false;
        }
        // this.resetEdit('workEdit');
        this.workEdit[index + 1] = true;
      } else {
        this.nextStep();
      }
    },
    projectEditAction(index) {
      this.projectEditStatus = "edit";
      this.projectEdit[index] = true;
    },
    projectEditSuc({ index, type }) {
      const eduLength = this.projectExperienceList.length;
      this.projectEditStatus = "add";
      if (eduLength > index + 1) {
        this.projectactiveNames = index + 1;
        // this.resetEdit('projectEdit');
        if (type) {
          this.projectEdit[index] = true;
        } else {
          this.projectEdit[index] = false;
        }
        this.projectEdit[index + 1] = true;
        console.log(this.projectEdit);
      } else {
        this.nextStep();
      }
    },
    resetEdit(key) {
      Object.keys(this[key]).map(item => {
        this[key][item] = false;
      });
    },
    beforeUploadAction() {
      this.fullloading = this.$loading({
        lock: true,
        text: "上传并解析中...,请耐心等待",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    editEducational(index) {
      this.projectEditStatus = "edit";
      this.educationalEdit[index] = true;
    },
    editJobExpect(index) {
      this.projectEditStatus = "edit";
      this.jobExpectEdit[index] = true;
    },
    async addEducationAction(index) {
      const validate = await this.$refs["educational"][index].validate();
      if (!validate) return;
      const res = this.addEducation(this.educationalBackgroundList[index]);
      if (res.code === 200) {
        this.$message.success("修改成功");
      }
    },
    
    //添加求职期望
    async addJobExpectList(type) {
      if (type === "new") {
        this.JobExpectateList.push({});
      }else {
        this.JobExpectateList[0] = {};
      }
      let index = this.JobExpectateList.length - 1;
      this.changeEditStatu("JobExpectateEdit", index);
      this.JobExpectateStatus = "add";
    },
    changeEditStatu(type, index) {
      // 刷新用户信息
      this.JobExpectateStatus = "edit";
      this.resetEdit(type);
      this[type][index] = true;
    },
    async jobExpectEditSuc() {
      const expect = await this.getJobExpect();  
      this.JobExpectateList = expect.data || [];
      this.resetEdit("JobExpectateEdit");
      this.setNewEdit("JobExpectateEdit", expect.data.length);
    },
    setNewEdit(key, item) {
      for (let i = 0; i < item; i++) {
        this.$set(this[key], i, false);
      }
    },
    async deleteJobExpectItem(type, id) {
      // 刷新用户信息
      //await this.getUserInfo();
      const action = this[type];
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const res = await action(id);
        if (res) {
          const expect = await this.getJobExpect();  
          this.JobExpectateList = expect.data || [];
          //this.getInitDate();
          return this.$message.success("删除成功");
        }
      });
    },
    
  }
};
</script>

<style lang="less" rel="stylesheet/less">
.infoBg{
  background: linear-gradient(163deg, #51B3FA 0%, #287CF3 100%);
}
.completeresume {
  min-height: 550px;
  width: 900px;
  background-color: #fff;
  margin: 20px auto 0;
  box-sizing: border-box;
  padding: 20px;
  position: relative;
  &-content {
    width: 720px;
    margin: 20px auto 0 auto;
    &-onetitle{
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0,0,0,0.88);
      line-height: 28px;
      padding-bottom: 6px;
    }
    &-onesubtitle{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0,0,0,0.55);
      line-height: 20px;
      padding-bottom: 30px;
    }
    .analyzing-resumes{
      .education-edit{
        background: none;
      }
      .el-collapse{
        border-top: none;
        border-bottom: none;
      }
      .el-collapse-item__wrap{
        border: none;
      }
      .work-edit{
        background: none !important;
      }
     
    }

    .el-select {
      width: 100%;
    }
  }
  &-upload {
    width: 50%;
    margin: 0 auto;
    padding-top: 50px;
    .el-upload {
      width: 100%;
      &__text{
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0,0,0,0.85);
        line-height: 22px;
        padding-top: 100px;
      }
      &__subtext{
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0,0,0,0.45);
        line-height: 17px;
        padding: 10px 0;
      }
      &__btn{
        width: 160px;
        height: 40px;
        margin: 0 auto;
        background: #287CF3;
        box-shadow: 0px 0px 1px 0px rgba(0,27,102,0.08), 0px 1px 4px -1px rgba(0,42,140,0.08), 0px 2px 8px -2px rgba(0,27,102,0.08);
        border-radius: 4px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 40px;
        margin-top: 40px;
      }

    }
    .el-upload-dragger {
      width: 100%;
      height: 300px;
      .el-icon-upload {
        margin-top: 100px;
      }
    }
    h2 {
     
      margin-bottom: 20px;
      font-weight: 300;
    }
  }
  &-list {
    .el-collapse-item.is-active {
      position: relative;
      .edit-tools {
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
        right: 40px;
        display: none;
        i {
          font-size: 20px;
          margin-left: 10px;
          cursor: pointer;
          &:hover {
            color: #2f74ff;
          }
        }
      }
      &:hover {
        .edit-tools {
          display: block;
        }
      }
    }
    &-jobexpect{
      h3{
        padding-bottom: 10px;
      }
      h2{
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: rgba(0,0,0,0.85);
        line-height: 30px;
      }
      &-title{
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: rgba(0,0,0,0.85);
      }
      &-edit{
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #287CF3;
        cursor: pointer;
      }
      p{
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: rgba(0,0,0,0.85);
        line-height: 20px;
      }
      .edit-tools{
        cursor: pointer;
      }
      
    }

  }
}
.editor {
  .ql-container {
    min-height: 300px;
  }
}
</style>
